export default __webpack_public_path__ + "static/media/sad_mans_3.8cf8fbc6.png";